module.exports = __webpack_public_path__ + "static/media/siddharth-mysuru-trip.98417da9.png";